export const INVOICE_ISSUED = "ISSUED_INVOICE";
export const INVOICE_PAID = "INVOICE_PAID";
export const INVOICE_MARKED_OVERDUE = "INVOICE_MARKED_OVERDUE";
export const USER_CREATED = "USER_CREATED";
export const SUBSCRIPTION_CHANGED = "SUBSCRIPTION_CHANGED";
export const SUBSCRIPTION_CANCELLED = "SUBSCRIPTION_CANCELLED";
export const CREDIT_NOTE_ISSUED = "ISSUED_CREDIT_NOTE";
export const REMINDER_SENT = "REMINDER_SENT";
export const ACCOUNT_STATEMENT_SENT = "ACCOUNT_STATEMENT_SENT";
export const BOOKING_CREATED = "BOOKING_CREATED";
export const BOOKING_CANCELLED = "BOOKING_CANCELLED";
export const BOOKING_RESCHEDULED = "BOOKING_RESCHELUED";
export const BOOKING_PAID = "BOOKING_PAID";
export const BOOKING_REFUNDED = "BOOKING_REFUNDED";
export const BOOKING_PAYMENT_REMINDER_SENT = "BOOKING_PAYMENT_REMINDER_SENT";
